<div class="collapsible-text" *ngIf="data">
    <div class="collapsible-header"
        tabindex="0"
        (click)="headerClick($event)"
        (keydown)="headerClick($event)"
    >
        <finder-font-icon
            class="icon"
            [htmlEntity]="icon"
        ></finder-font-icon>
        <finder-component-header
            [data]="data.collapsibleText"
        ></finder-component-header>
    </div>
    <div class="collapsible-content generic-text dynamic-html" #content
        [innerHTML]="data.collapsibleText?.text | safeHtml"
    ></div>
</div>
